import http from '@sar/http'
import engine from '@sar/framework'

import React from 'react'
import ReactDOM from 'react-dom/client'

import Assembly from 'views/assembly'
import Aftersales from 'views/aftersales'
import Recycling from 'views/recycling'

import Collection from 'views/collection'
import Data from 'views/data'
import Order from 'views/order'

import Root from 'views/root'
import Login from 'views/login'
import Split from 'views/split'

import Price from 'views/price'
import Placeorder from 'views/placeorder'
import Production from 'views/production'

import Design from 'views/design'
import Customer from 'views/customer'
import Addressing from 'views/addressing'

import Home from 'views/home'
import System from 'views/system'
import Nomatch from 'views/nomatch'
import Unauthorized from 'views/unauthorized'

import Layout from 'plugins/layout'
import Inject from 'plugins/inject'

import Verify from 'plugins/verify'
import Preload from 'plugins/preload'

import oss from 'hooks/oss'
import assets from 'hooks/assets'
import config from 'hooks/config'

import data from 'hooks/data'
import history from 'hooks/history'

import encrypt from 'hooks/encrypt'
import identity from 'hooks/identity'
import externals from 'hooks/externals'

import query from 'middlewares/query'
import author from 'middlewares/author'
import notification from 'middlewares/notification'

const APP = (
  engine
    .create()
    .set((app: engine) => app.usePlugin(Verify))
    .set((app: engine) => app.usePlugin(Layout))
    .set((app: engine) => app.usePlugin(Preload))
    .set((app: engine) => app.usePlugin(Inject))
    .set((app: engine) => app.usePrefix(APP_ENV.prefix))
    .set((app: engine) => app.useStore('oss', oss))
    .set((app: engine) => app.useStore('data', data))
    .set((app: engine) => app.useStore('assets', assets))
    .set((app: engine) => app.useStore('config', config))
    .set((app: engine) => app.useStore('history', history))
    .set((app: engine) => app.useStore('encrypt', encrypt))
    .set((app: engine) => app.useStore('identity', identity))
    .set((app: engine) => app.useStore('externals', externals))
    .set((app: engine) => app.useRoute('/403', Unauthorized))
    .set((app: engine) => app.useRoute('/404', Nomatch))
    .set((app: engine) => app.useRoute('/home', Home))
    .set((app: engine) => app.useRoute('/login', Login))
    .set((app: engine) => app.useRoute('/nomatch',  Nomatch))
    .set((app: engine) => app.useRoute('/addressing', Addressing))
    .set((app: engine) => app.useRouter('/assembly', Assembly))
    .set((app: engine) => app.useRouter('/assembly', Assembly))
    .set((app: engine) => app.useRouter('/aftersales', Aftersales))
    .set((app: engine) => app.useRouter('/collection', Collection))
    .set((app: engine) => app.useRouter('/customer', Customer))
    .set((app: engine) => app.useRouter('/data', Data))
    .set((app: engine) => app.useRouter('/design', Design))
    .set((app: engine) => app.useRouter('/split', Split))
    .set((app: engine) => app.useRouter('/system', System))
    .set((app: engine) => app.useRouter('/order', Order))
    .set((app: engine) => app.useRouter('/price', Price))
    .set((app: engine) => app.useRouter('/recycling', Recycling))
    .set((app: engine) => app.useRouter('/placeorder', Placeorder))
    .set((app: engine) => app.useRouter('/production', Production))
    .set((app: engine) => app.useRedirect('/', '/addressing'))
    .set((app: engine) => app.useRedirect('/*', '/nomatch'))
)

http.setting('base', APP_ENV.endpoint)
http.setting('adapter', APP_ENV.adapter)

http.useProxy('request', author)
http.useProxy('request', query)
http.useProxy('response', notification)

moment.locale('en-au')
moment.locale('zh-cn')

ReactDOM.createRoot(document.getElementById('root')).render(
  <Root>
    <APP.DOM store={APP}/>
  </Root>
)
